import axios from 'axios';
import fileHelper from 'shared/data/helpers/file';

export default {
  /**
   * Create team label
   */
  createLabel(teamId, label) {
    return axios
      .post('/api/team.createLabel', {
        params: { teamId },
        payload: label,
      })
      .then((res) => res.data);
  },

  /**
   * Remove team label
   */
  deleteLabel(teamId, labelId) {
    return axios
      .post('/api/team.deleteLabel', {
        params: { teamId, labelId },
      })
      .then((res) => res.data);
  },

  /**
   * Update team label
   */
  updateLabel(teamId, labelId, changes) {
    return axios
      .post('/api/team.updateLabel', {
        params: { teamId, labelId },
        payload: changes,
      })
      .then((res) => res.data);
  },

  /**
   * Activate global element manager for team
   */
  activateGlobalElementManager(teamId) {
    return axios
      .post('/api/team.activateGlobalElementManager', {
        params: { teamId },
      })
      .then((res) => res.data);
  },

  /**
   * Get a team by team ID
   */
  get(teamId) {
    return axios
      .post('/api/team.get', {
        params: { teamId },
      })
      .then((res) => res.data);
  },

  /**
   * Get a team by team ID for guest
   */
  getForGuest(teamId) {
    return axios
      .post('/api/team.getForGuest', {
        params: { teamId },
      })
      .then((res) => res.data);
  },

  /**
   * Check for existing team by title
   *
   */
  checkForExistingTitle(title) {
    return axios
      .post('/api/team.checkForExistingTitle', {
        params: { title: encodeURIComponent(title) },
      })
      .then((res) => res.data);
  },

  /**
   * Create a team
   *
   */
  create(team) {
    return axios
      .post('/api/team.create', {
        payload: team,
      })
      .then((res) => res.data);
  },

  /**
   * Get teams for a user ID
   */
  getByUserId(userId) {
    return axios
      .post('/api/team.getByUserId', {
        params: { userId: userId },
      })
      .then((result) => result.data);
  },

  /**
   * Get list of team role types
   */
  getRoleTypes() {
    // Empty payload obj sent to fix IE "Unsupported Media Type" error
    return axios
      .post('/api/team.getRoleTypes', {
        payload: {},
      })
      .then((res) => res.data);
  },

  /**
   * Get a list of team roles
   */
  getRoles(teamId) {
    return axios
      .post('/api/team.getRoles', {
        params: { teamId },
      })
      .then((res) => res.data);
  },

  /**
   * Update a team
   */
  update(teamId, changes) {
    return axios
      .post('/api/team.update', {
        params: { teamId },
        payload: changes,
      })
      .then((res) => res.data);
  },

  /**
   * Update team photo
   */
  updatePhoto(teamId, file) {
    return fileHelper.upload('/api/upload/team.updatePhoto', { teamId }, file);
  },
};
